export enum TypographyVariants {
  'h1' = 'h1',
  'h2' = 'h2',
  'h3' = 'h3',
  'h4' = 'h4',
  'h5' = 'h5',
  'h6' = 'h6',
  'body1' = 'body1',
  'body2' = 'body2',
  'body3' = 'body3',
  'body4' = 'body4',
  'body5' = 'body5',
  'body6' = 'body6',
  'body7' = 'body7',
  'subtitle1' = 'subtitle1',
  'subtitle2' = 'subtitle2',
  'headline1' = 'headline1',
  'headline2' = 'headline2',
  'headline3' = 'headline3',
  'headline4' = 'headline4',
}
export type TypographyVariant = keyof typeof TypographyVariants;

export default function createTypography(): Record<
  TypographyVariant,
  Record<string, string | number>
> {
  return {
    h1: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 900,
      fontSize: 124,
      lineHeight: 1,
    },
    h2: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 900,
      fontSize: 80,
      lineHeight: 1,
    },
    h3: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 900,
      fontSize: 48,
      lineHeight: 1,
    },
    h4: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 700,
      fontSize: 36,
      lineHeight: '40px',
    },
    h5: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 500,
      fontSize: 32,
      lineHeight: '36px',
    },
    h6: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 500,
      fontSize: 28,
      lineHeight: '32px',
    },
    body1: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: 20,
      lineHeight: '24px',
      letterSpacing: '0.008em',
    },
    body2: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '20px',
      letterSpacing: '0.008em',
    },
    body3: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '18px',
      letterSpacing: '0.008em',
    },
    body4: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: 13,
      lineHeight: '16px',
      letterSpacing: '0.008em',
    },
    body5: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      letterSpacing: '0.008em',
    },
    body6: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: 11,
      lineHeight: '14px',
      letterSpacing: '0.008em',
    },
    body7: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 400,
      fontSize: 10,
      lineHeight: '14px',
      letterSpacing: '0.008em',
    },
    subtitle1: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 500,
      fontSize: 12,
      lineHeight: '16px',
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
    },
    subtitle2: {
      fontFamily: '"Roboto", sans-serif',
      fontWeight: 500,
      fontSize: 11,
      lineHeight: '14px',
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
    },
    headline1: {
      fontFamily: '"PF Benchmark Pro", serif',
      fontWeight: 700,
      fontSize: 56,
      lineHeight: '60px',
      textTransform: 'uppercase',
    },
    headline2: {
      fontFamily: '"PF Benchmark Pro", serif',
      fontWeight: 700,
      fontSize: 30,
      lineHeight: '32px',
      textTransform: 'uppercase',
    },
    headline3: {
      fontFamily: '"PF Benchmark Pro", serif',
      fontWeight: 700,
      fontSize: 22,
      lineHeight: '24px',
      textTransform: 'uppercase',
    },
    headline4: {
      fontFamily: '"PF Benchmark Pro", serif',
      fontWeight: 700,
      fontSize: 10,
      lineHeight: '12px',
      textTransform: 'uppercase',
    },
  };
}
